import React from 'react';

interface MaterialIconProps {
  name: string;
  filled?: boolean;
  className?: string;
  size?: number;
}

export default function MaterialIcon({
  name,
  filled = false,
  className = '',
  size = 24,
}: MaterialIconProps) {
  return (
    <span
      className={`material-symbols-outlined ${filled ? 'filled' : ''} ${className}`.trim()}
      style={{ fontSize: size }}
      aria-hidden
    >
      {name}
    </span>
  );
}
